export const isNotSupportedFile = (allowed: string[]) => (file: File) => {
  if (allowed.length === 0) {
    return false;
  }

  const ext = file.name.split('.').pop();

  return !ext || !allowed.includes(`.${ext.toLowerCase()}`);
};
